/**
 * The daily writing habit as the Goals tool first stored it. Goals now keep it
 * as a writing goal (see stores/goals), which migrates it from here once.
 */
export interface WritingHabit {
  enabled: boolean
  /** Net words that make a writing day; 0 means words don't count. */
  dailyWords: number
  /** Active writing minutes that make a writing day; 0 means time doesn't count. */
  dailyMinutes: number
  /** Writing days per week that keep the streak alive. */
  daysPerWeek: number
  /** 0 = Sunday, 1 = Monday. */
  weekStartsOn: 0 | 1
  /** Hour (0–6) at which a new writing day begins, for writers who work past midnight. */
  dayStartHour: number
  /** Finishing an Editor Mode revision pass also makes a writing day. */
  passDays: boolean
}

export const DEFAULT_WRITING_HABIT: WritingHabit = {
  enabled: false,
  dailyWords: 500,
  dailyMinutes: 30,
  daysPerWeek: 5,
  weekStartsOn: 1,
  dayStartHour: 0,
  passDays: true,
}

export function normalizeWritingHabit(raw: any): WritingHabit {
  const whole = (value: unknown, min: number, max: number, fallback: number) => {
    const n = Math.round(Number(value))
    return Number.isFinite(n) ? Math.min(max, Math.max(min, n)) : fallback
  }
  const d = DEFAULT_WRITING_HABIT
  const habit: WritingHabit = {
    enabled: raw?.enabled === true,
    dailyWords: whole(raw?.dailyWords, 0, 100_000, d.dailyWords),
    dailyMinutes: whole(raw?.dailyMinutes, 0, 1_440, d.dailyMinutes),
    daysPerWeek: whole(raw?.daysPerWeek, 1, 7, d.daysPerWeek),
    weekStartsOn: raw?.weekStartsOn === 0 ? 0 : 1,
    dayStartHour: whole(raw?.dayStartHour, 0, 6, d.dayStartHour),
    passDays: raw?.passDays !== false,
  }
  // A habit needs at least one way to qualify.
  if (habit.dailyWords === 0 && habit.dailyMinutes === 0) habit.dailyWords = d.dailyWords
  return habit
}
